import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleArchiveAdministrationComponent } from './vehicle-archive-administration/vehicle-archive-administration.component';
import { CommonLayoutModule, CommonUIBasicModule, CommonUIButtonsModule, CommonUIElementsModule, CommonUIFormularModule, PagedContentModule, TranslationComponentsModule } from '@sdbn/common';
import { ConditionsModule } from '@sdbn/common-extended';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { VehicleArchiveAdministrationWidgetComponent } from './vehicle-archive-administration-widget/vehicle-archive-administration-widget.component';



@NgModule({
  declarations: [
    VehicleArchiveAdministrationComponent,
    VehicleArchiveAdministrationWidgetComponent
  ],
  imports: [
    CommonModule,
    PagedContentModule,
    CommonUIElementsModule,
    CommonUIFormularModule,
    CommonUIButtonsModule,
    CommonLayoutModule,
    CommonUIBasicModule,
    ConditionsModule,
    CdkDropList,
    CdkDrag,
    TranslationComponentsModule
  ]
})
export class VehicleArchiveAdministrationModule { }
